import React from "react";
import { connect } from "react-redux";
import { getUser, userSignOut } from "appRedux/actions/auth";

function AppComponent(props) {
  const { component, path } = props;

  return React.createElement(component, {
    path: path,
    props: props,
    ...props,
  });
}

const mapStateToProps = ({ auth, permission }) => {
  const { authUser } = auth;
  const { user_permissions } = permission;
  return { authUser, user_permissions };
};

export default connect(mapStateToProps, { getUser, userSignOut })(AppComponent);
